import React from 'react';
import { FileContextProvider } from '../Provider';
import { FileSelectModal } from './FileSelectModal';

/**
 *
 *  Allows uploading files globally to bukku's file select
 *  PROPS:
 *  - visible: boolean --- (is file select modal visible)
 *  - mode: String --- 'multiple', 'single'. ('single' if unspecified)
 *  - onOk: submit files
 *  - onCancel: close file select modal
 *  - fileTypeFilter: specific file types to be shown in File Select (IMAGES, VIDEO, PDF, EXCEL)
 *  - initFiles: [] --- files selected by parent (Contact / Transaction)
 *
 *  FileContext:
 *  - contextState: Object {} --- state of file select (refer inside FileContextProvider)
 *  - contextAction: Object {} --- actions of file select that deals with state management
 *                             --- (refer inside FileContextProvider)
 *  - contextProps: Object {} --- props of file select (same as props list above)
 */
export function FileSelect(props) {
    return (
        // Provider contains lifecycle methods, and logic-related helper functions
        <FileContextProvider {...props}>
            <FileSelectModal />
        </FileContextProvider>
    );
}
